import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { device } from "../../../constants/mediaQueries";
import { withWSErrorContainer } from "../../../error/withWSErrorContainer";
import { SideNavMenu } from "./SideMenuNav";

export const SideMenu = withWSErrorContainer(
  observer(() => {
    return (
      <StyledSideMenu className="cvp-side-menu">
        <StyledSideMenuContainer className="cvp-side-menu-container">
          <SideNavMenu />
        </StyledSideMenuContainer>
      </StyledSideMenu>
    );
  })
);

export const sideMenuLgWidth = 100;
export const sideMenuXlWidth = 250;

const StyledSideMenu = styled.div`
  &.cvp-side-menu {
    flex-shrink: 0;
    white-space: nowrap;
    box-sizing: border-box;
    display: none;
    width: ${sideMenuLgWidth}px;

    .p-menuitem-text.p-menuitem-text {
      line-height: normal;
    }

    @media ${device.md} {
      display: block;
    }

    @media ${device.xl} {
      width: ${sideMenuXlWidth}px;
    }
  }
`;

const StyledSideMenuContainer = styled.div`
  &.cvp-side-menu-container {
    border-right: 1px solid var(--primary-100-relative);
    background: var(--surface-a);
    overflow: hidden;
    width: inherit;
    height: 100%;
    user-select: none;
    z-index: 1;
    position: fixed;
    top: 0px;
    left: 0px;
  }
`;
